import { render, staticRenderFns } from "./SubmitContainer.vue?vue&type=template&id=0d059c24&"
import script from "./SubmitContainer.vue?vue&type=script&lang=js&"
export * from "./SubmitContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports